import { render, staticRenderFns } from "./reviewer_submission_details.vue?vue&type=template&id=72e7f618&scoped=true&"
import script from "./reviewer_submission_details.vue?vue&type=script&lang=js&"
export * from "./reviewer_submission_details.vue?vue&type=script&lang=js&"
import style0 from "./reviewer_submission_details.vue?vue&type=style&index=0&id=72e7f618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7f618",
  null
  
)

export default component.exports